export default "__VITE_ASSET__7ON102n$__"